import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import {Options, isPrivacyAccepted} from "../utils/decorators";
import Favorites from '../favorites/favorites';

interface Favorite {
    performanceID: number,
    timestamp: number,
}

@Options({
    template: false,
    ui: {
        acceptButton: "[data-js-ui=accept-button]",
    },
})
export default class CollectionButton extends Marionette.View<Backbone.Model>{
    element: HTMLElement;
    button: HTMLElement;
    performances: any[];

    constructor(options?:object) {
        super(options);

        let el = (this.$el as any);
        this.element = el.get(0) as HTMLElement;
        this.button = this.element.querySelector('.collection-cta__button');

        this.performances = (<any>window).performancesJSON;
    }


    onRender() {
        let href = Favorites.getBlocksofficeURL();

        this.button.setAttribute('href', href);

        this.button.addEventListener('click', event => {
            event.preventDefault();
            Favorites.favoriteMultiple(this.performances);

            this.button.classList.add('loading');
            this.button.classList.add('btn-disabled');
            this.button.textContent = 'Adding performances...';

            setTimeout(() => {
                window.location.href = href;
            }, 50);
        });

        let privacyPopup = <HTMLElement>document.querySelector('.privacy-popup');

        let popupHeight = privacyPopup.offsetHeight;

        if (!isPrivacyAccepted()) {
            this.element.style.borderBottomWidth = (popupHeight + 20) + 'px';
        }

        document.querySelector('[data-js-view="privacy-accept-view"] .btn--close-menu').addEventListener('click', () => {
            this.element.style.borderBottomWidth = '15px';
        });
    }
}



// WEBPACK FOOTER //
// ./@modules/views/collection-button.ts